/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */
import { CLEAR_REQUEST_STATUS } from 'state/requests/RequestStatusReducer';
export const RECEIVED_GRANT_VIEW_ACCESS_ADD_USER_AUTH =
  'RECEIVED_GRANT_VIEW_ACCESS_ADD_USER_AUTH';
export const receivedGrantViewAccessAddUserAuth = (accounts) => ({
  type: RECEIVED_GRANT_VIEW_ACCESS_ADD_USER_AUTH,
  accounts
});

export const REQUESTED_GRANT_VIEW_ACCESS_ADD_USER_AUTH =
  'REQUESTED_GRANT_VIEW_ACCESS_ADD_USER_AUTH';
export const requestedGrantViewAccessAddUserAuth = () => ({
  type: REQUESTED_GRANT_VIEW_ACCESS_ADD_USER_AUTH
});

export const ERROR_GRANT_VIEW_ACCESS_ADD_USER_AUTH =
  'ERROR_GRANT_VIEW_ACCESS_ADD_USER_AUTH';
export const errorGrantViewAccessAddUserAuth = (error) => ({
  type: ERROR_GRANT_VIEW_ACCESS_ADD_USER_AUTH,
  error
});

export const CLEAR_GRANT_VIEW_ACCESS_ADD_USER_AUTH =
  'CLEAR_GRANT_VIEW_ACCESS_ADD_USER_AUTH';
export const clearGrantViewAccessAddUserAuth = () => ({
  type: CLEAR_GRANT_VIEW_ACCESS_ADD_USER_AUTH
});

export const REQUESTED_VIEW_RELATIONSHIPS = 'REQUESTED_VIEW_RELATIONSHIPS';
export const requestedViewRelationships = () => ({
  type: REQUESTED_VIEW_RELATIONSHIPS
});

export const RECEIVED_VIEW_RELATIONSHIPS = 'RECEIVED_VIEW_RELATIONSHIPS';
export const receivedViewRelationships = (viewRelationships) => ({
  type: RECEIVED_VIEW_RELATIONSHIPS,
  viewRelationships
});

export const ERROR_VIEW_RELATIONSHIPS = 'ERROR_VIEW_RELATIONSHIPS';
export const errorViewRelationships = (error) => ({
  type: ERROR_VIEW_RELATIONSHIPS,
  error
});

export const REQUESTED_UPDATE_VIEW_RELATIONSHIPS =
  'REQUESTED_UPDATE_VIEW_RELATIONSHIPS';
export const REQUESTED_ADD_VIEW_RELATIONSHIPS =
    'REQUESTED_ADD_VIEW_RELATIONSHIPS';
export const requestedUpdateViewRelationships = () => ({
  type: REQUESTED_UPDATE_VIEW_RELATIONSHIPS
});
export const requestedAddViewRelationships = () => ({
  type: REQUESTED_ADD_VIEW_RELATIONSHIPS
});

export const RECEIVED_UPDATE_VIEW_RELATIONSHIPS =
  'RECEIVED_UPDATE_VIEW_RELATIONSHIPS';
export const RECEIVED_ADD_VIEW_RELATIONSHIPS =
    'RECEIVED_ADD_VIEW_RELATIONSHIPS';
export const receivedUpdateViewRelationships = (viewRelationships) => ({
  type: RECEIVED_UPDATE_VIEW_RELATIONSHIPS,
  viewRelationships
});
export const receivedAddViewRelationships = (viewRelationships) => ({
  type: RECEIVED_ADD_VIEW_RELATIONSHIPS,
  viewRelationships
});

export const ERROR_UPDATE_VIEW_RELATIONSHIPS =
  'ERROR_UPDATE_VIEW_RELATIONSHIPS';
export const ERROR_ADD_VIEW_RELATIONSHIPS =
    'ERROR_ADD_VIEW_RELATIONSHIPS';
export const errorUpdateViewRelationships = (error) => ({
  type: ERROR_UPDATE_VIEW_RELATIONSHIPS,
  error
});
export const errorAddViewRelationships = (error) => ({
  type: ERROR_ADD_VIEW_RELATIONSHIPS,
  error
});

export const REQUESTED_DELETE_GRANT_VIEW_ACCESS_USER =
  'REQUESTED_DELETE_GRANT_VIEW_ACCESS_USER';
export const requestDeleteGrantViewAccessUser = () => ({
  type: REQUESTED_DELETE_GRANT_VIEW_ACCESS_USER
});

export const ERROR_DELETE_GRANT_VIEW_ACCESS_USER =
  'ERROR_DELETE_GRANT_VIEW_ACCESS_USER';
export const deleteGrantViewAcessError = (error) => ({
  type: ERROR_DELETE_GRANT_VIEW_ACCESS_USER,
  error
});

export const RECEIVED_DELETE_GRANT_VIEW_ACCESS_USER =
  'RECEIVED_DELETE_GRANT_VIEW_ACCESS_USER';
export const receivedDeleteGrantViewAccessUser = (viewRelationships) => ({
  type: RECEIVED_DELETE_GRANT_VIEW_ACCESS_USER,
  viewRelationships
});

export const SET_ACTIVE_EDIT_CUSTOMER = 'SET_ACTIVE_EDIT_CUSTOMER';
export const setViewAccessSelection = (customerIndex) => ({
  type: SET_ACTIVE_EDIT_CUSTOMER,
  customerIndex
});

export const SET_VIEW_ACCESS_SELECTION = 'SET_VIEW_ACCESS_SELECTION';
export const setViewAccessSelections = (selection) => ({
  type: SET_VIEW_ACCESS_SELECTION,
  selection
});

export const RESET_VIEW_ACCESS_SELECTIONS = 'RESET_VIEW_ACCESS_SELECTIONS';
export const resetViewAccessSelections = () => ({
  type: RESET_VIEW_ACCESS_SELECTIONS
});

export const resetGrantViewAccessAddUserAuth = () => ({
  type: CLEAR_REQUEST_STATUS,
  payload: {
    requestStatus: 'grantViewAccessAddUserAuth'
  }
});

export const resetDeleteGrantViewAccessUser = () => ({
  type: CLEAR_REQUEST_STATUS,
  payload: {
    requestStatus: 'deleteGrantViewAccessUser'
  }
});

export const resetGrantViewAccessUpdateRelationships = () => ({
  type: CLEAR_REQUEST_STATUS,
  payload: {
    requestStatus: 'updateViewRelationships'
  }
});

